import { cn } from "cn";
import type { FC } from "react";
import React from "react";

import { Skeleton } from "@react/ui-primitives/skeleton";

interface GithubCommentCardSkeletonProps {
  readonly className?: string;
}

export const GithubCommentCardSkeleton: FC<GithubCommentCardSkeletonProps> = ({
  className,
}) => (
  <div className={cn("flex flex-col gap-1 rounded-md border p-3", className)}>
    <div className="flex items-center justify-between">
      <Skeleton className="w-32" variant="text-label" />
      <Skeleton className="w-24" variant="text-label" />
    </div>
    <Skeleton className="w-40" variant="text-label" />
    <Skeleton variant="text-line" />
  </div>
);
